var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFe3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 48096542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.53002 9.93006H24.36C24.78 9.93006 25.15 9.66006 25.28 9.25006C25.41 8.85006 25.26 8.41006 24.91 8.17006L13.49 0.170059C13.16 -0.0599414 12.71 -0.0599414 12.38 0.170059L0.960019 8.17006C0.640019 8.42006 0.490019 8.85006 0.610019 9.25006C0.740019 9.66006 1.11002 9.93006 1.53002 9.93006ZM12.95 2.15006L21.3 8.00006H4.60002L12.95 2.15006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.37012 12.8301V21.7301C3.37012 22.2601 3.80012 22.7001 4.34012 22.7001C4.88012 22.7001 5.31012 22.2701 5.31012 21.7301V12.8301C5.31012 12.3001 4.88012 11.8601 4.34012 11.8601C3.80012 11.8601 3.37012 12.3001 3.37012 12.8301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.8101 12.8301V21.7301C11.8101 22.2601 12.2401 22.7001 12.7801 22.7001C13.3201 22.7001 13.7501 22.2701 13.7501 21.7301V12.8301C13.7501 12.3001 13.3201 11.8601 12.7801 11.8601C12.2401 11.8601 11.8101 12.3001 11.8101 12.8301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.2397 12.8301V14.3901C20.2397 14.9201 20.6697 15.3601 21.2097 15.3601C21.7497 15.3601 22.1797 14.9301 22.1797 14.3901V12.8301C22.1797 12.3001 21.7497 11.8601 21.2097 11.8601C20.6697 11.8601 20.2397 12.3001 20.2397 12.8301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5199 24.8401H1.13992C0.609922 24.8401 0.169922 25.2701 0.169922 25.8101C0.169922 26.3501 0.599922 26.7801 1.13992 26.7801H13.5099C14.0399 26.7801 14.4799 26.3501 14.4799 25.8101C14.4799 25.2701 14.0499 24.8401 13.5199 24.8401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M29.2301 18.8401C28.9001 18.5301 28.4601 18.3701 27.8901 18.3701C27.8601 18.3701 27.7801 18.3801 27.5601 18.3801C27.3101 18.3801 26.6501 18.3601 26.0501 18.2201C25.6001 18.1101 24.9301 17.5701 24.6001 17.3101C24.4301 17.1701 24.3001 17.0701 24.2101 17.0201C23.6201 16.6301 22.8201 16.6201 22.1801 17.0301C22.1401 17.0601 22.0501 17.1301 22.0101 17.1701C21.1501 17.9901 20.6001 18.1801 20.4001 18.2301C19.8101 18.3701 19.1401 18.3901 18.8801 18.3901C18.7101 18.3901 18.6001 18.3801 18.4501 18.3801C17.9901 18.3801 17.5501 18.5501 17.2101 18.8501C16.8301 19.1901 16.6201 19.6701 16.6201 20.1801V22.2701C16.6201 30.7701 22.6101 31.9401 22.8801 31.9901C22.9801 32.0101 23.0901 32.0201 23.1901 32.0201C23.2901 32.0201 23.4001 32.0101 23.5101 31.9901C23.7701 31.9401 29.7901 30.7701 29.7901 22.2801V20.1901C29.8201 19.6601 29.6001 19.1801 29.2301 18.8401ZM27.8901 22.2601C27.8901 29.1501 23.3901 30.0401 23.2301 30.0701C23.0401 30.0401 18.5801 29.1601 18.5801 22.2601V20.3001C18.8701 20.3101 19.8401 20.3401 20.8701 20.1001C21.5901 19.9301 22.4001 19.4501 23.2301 18.6801C23.2801 18.7201 23.3301 18.7601 23.4001 18.8101C23.9001 19.2201 24.7401 19.8901 25.6101 20.1001C26.6601 20.3501 27.6601 20.3301 27.8901 20.3001V22.2601Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFe3);
export default __webpack_public_path__ + "static/media/fe-3.bc55dd0be00c5f05edc47cb30b3e59c1.svg";
export { ForwardRef as ReactComponent };